export const learnAboutMsaUrl =
  "https://docs.microsoft.com/azure/active-directory/external-identities/microsoft-account";

export const idAtXboxUrl = "https://news.xbox.com/en-us/idatxbox/";

export const idXboxAccelerationProgramUrl =
  "https://news.xbox.com/en-us/2023/03/21/id-xbox-developer-acceleration-program-underrepresented-creators/";

export const uwpStorePoliciesUrl = "https://docs.microsoft.com/windows/uwp/publish/store-policies";

export const liveXblOverviewUrl =
  "https://docs.microsoft.com/gaming/gdk/_content/gc/live/get-started/live-xbl-overview";

export const partnerCenterUrl = "https://developer.microsoft.com/microsoft-store/register/";

export const microsoftGraphProfilePictureUrl = "https://graph.microsoft.com/v1.0/me/photo/$value";

export const microsoftGraphProfileUrl = "https://graph.microsoft.com/v1.0/me/";

export const privacyPolicyURL = "https://privacy.microsoft.com/privacystatement";

export const appDeveloperAgreement = "http://go.microsoft.com/fwlink/?LinkId=528905";

export const linkToPitchForm = "https://forms.office.com/r/UauihhdMiB";

export const siteLocationPrefix = "/games/publish";

// Dev Resources
export const GameDevelopmentUrl = "https://docs.microsoft.com/gaming/";
export const GdkDocumentsUrl = "https://aka.ms/gamedevdocs";
export const XboxGdkSamplesUrl = "https://github.com/microsoft/Xbox-GDK-Samples/";
export const LatestGdkReleaseUrl = "https://github.com/microsoft/GDK/releases";
export const XboxDevForumsUrl = "https://aka.ms/xboxdeveloperforums";
export const XgdUrl = "https://aka.ms/xgd";
export const GdkDownloadUrl = "https://aka.ms/gdkdl";
export const XboxPublisherGuideUrl = "https://aka.ms/xboxpublisherguide";
export const XdkDownloadUrl = "https://aka.ms/xgddl";
export const EdsUrl = "https://gamedevstore.partners.extranet.microsoft.com";
export const DevHubUrl = "https://microsoft.sharepoint.com/teams/IDAZDevelopers/";
export const IdAzureProgramDetailsUrl =
  "https://microsoft.sharepoint.com/teams/IDAZDevelopers/SitePages/Program-details.aspx";
export const AzureCreditsFaqUrl =
  "https://microsoft.sharepoint.com/teams/IDAZDevelopers/SitePages/FAQs.aspx#azure-credits";
export const PlayfabFaqUrl =
  "https://microsoft.sharepoint.com/teams/IDAZDevelopers/SitePages/FAQs.aspx#playfab";
export const EducationPortalUrl =
  "https://microsoft.sharepoint.com/teams/IDAZDevelopers/SitePages/Education-portal-page.aspx";
export const AskTheExpertsUrl =
  "https://microsoft.sharepoint.com/teams/IDAZDevelopers/SitePages/Office%20Hours%20+%20Expert%20Sessions.aspx";
